<div class="container">
  <pdq-heading element="h6">Bazaarvoice API Passkey</pdq-heading>
  <div class="general">
    <pdq-input
      [value]="bazaarvoicePasskey"
      placeholder="Not configured"
      [readonly]="true"
      type="password"
      [clipboard]="!!bazaarvoicePasskey"></pdq-input>
    @if (bazaarvoicePasskey) {
      <p class="hint body-12-regular">To change your Passkey, disconnect and reconnect.</p>
    } @else {
      <p class="hint body-12-regular">Click Connect at the top of the page to enter your Bazaarvoice API Passkey.</p>
    }
  </div>
</div>
